import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { LogoLockup } from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [pending, setPending] = useState(null); // {email, name} or null

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match?.[1];

    if (!sid) {
      nav("/");
      return;
    }

    (async () => {
      try {
        const isStudent = window.location.pathname.startsWith("/student");
        const { data } = await api.post("/auth/session", { intent: isStudent ? "student" : "owner" }, {
          headers: { "X-Session-ID": sid },
        });
        if (data.status === "pending") {
          setPending({ email: data.email, name: data.name });
          window.history.replaceState({}, document.title, "/");
          return;
        }
        setUser(data.user);
        const dest = isStudent ? "/student/home" : "/app";
        window.history.replaceState({}, document.title, dest);
        nav(dest, { replace: true, state: { user: data.user } });
      } catch (e) {
        nav("/", { replace: true });
      }
    })();
  }, [nav, setUser]);

  if (pending) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)", padding: 24 }}>
        <div className="card p-10 text-center max-w-[480px]" data-testid="pending-access">
          <div className="flex justify-center mb-7"><LogoLockup size={28} beltWidth={220} /></div>
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-5" style={{ background: "var(--green-bg)", border: "1px solid var(--green-border)" }}>
            <Check size={22} style={{ color: "var(--green)" }}/>
          </div>
          <h1 className="text-[24px] font-bold tracking-tight uppercase">Thanks for your interest</h1>
          <p className="mt-3 text-[14px]" style={{ color: "var(--text-dim)" }}>
            We're onboarding founding academies one-by-one. We've saved your details ({pending.email}) and will reach out as soon as a spot opens up for your academy.
          </p>
          <button onClick={()=>nav("/")} className="btn btn-outline mt-8" data-testid="pending-back">Back to home</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)" }}>
      <div className="label">Signing you in…</div>
    </div>
  );
}
